module.exports = __webpack_public_path__ + "static/media/GothamRnd-Book.e40570a3.otf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/GothamRnd-Book.otf
 ** module id = 1348
 ** module chunks = 0
 **/